
import { useNavigate } from "react-router-dom";

export default function ElectricityContracts() {
  const navigate = useNavigate();

  const contracts = [
    {
      id: "EC-2026-001",
      business: "ABC Company Ltd",
      supplier: "British Gas",
      start: "01 Mar 2026",
      end: "01 Mar 2027",
      status: "Active",
    },
    {
      id: "EC-2026-002",
      business: "XYZ Pvt Ltd",
      supplier: "EDF Energy",
      start: "15 Jan 2026",
      end: "15 Jan 2027",
      status: "Pending",
    },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-semibold mb-6">
        Electricity Contracts
      </h1>

      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-gray-50 text-gray-600 text-sm">
            <tr>
              <th className="p-4">Contract ID</th>
              <th>Business</th>
              <th>Supplier</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {contracts.map((c) => (
              <tr
                key={c.id}
                className="border-t hover:bg-gray-50 cursor-pointer"
                onClick={() => navigate(`/electricity/${c.id}`)}
              >
                <td className="p-4 text-blue-600">{c.id}</td>
                <td>{c.business}</td>
                <td>{c.supplier}</td>
                <td>{c.start}</td>
                <td>{c.end}</td>
                <td>
                  <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-600">
                    {c.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}